import React, { useEffect, useState } from 'react'
import { StyledCircleCheckIconWrapper } from '../../../LocalReceipts/Form/ProgressChecks/StyledCircleCheckIconWrapper'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import { useTranslation } from 'react-i18next'
import { isEmptyGuid } from '../../../../utils/emptyGuid'

const PositionsCheck = ({ positions }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    let valid = false
    if(positions.length)
    {
      valid = true
      for (const position of positions) {
        if (isEmptyGuid(position.article.id)) {
          valid = false
          break;
        }
        if (position.article.isWithSizes && isEmptyGuid(position.articleVariant?.id)) {
          valid = false
          break;
        }
        if (position.article.useSerialKeys && !position.serialkey) {
          valid = false
          break;
        }
        /*if (position.article.useSerialKeys && (position.quantityExpected != 1 || position.quantityCounted != 1)) {
          valid = false
          break;
        }*/
        if (position.article.useBatchKeys && !position.batchkey) {
          valid = false
          break;
        }
      }
    }
    setIsValid(valid)
  }, [positions])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('returnsReceiptOverlayProgress:positions')}</span>
    </>
  )
}

export default PositionsCheck
